import { getSessionAttendees } from '../selectors/sessionSelectors';
import { addAttendeeMutator } from '../mutators/attendeeMutators';
import { addAttendeeToMruCache } from '../mutators/attendeeMruCacheMutators';

export function ensureAttendeeAddedToSession(sessionId: string, key: string): void {
    if (!getSessionAttendees(sessionId).some(a => a == key)) {
        addAttendeeMutator(sessionId, key);
        addAttendeeToMruCache(key);
    }
}
